import React from 'react';
import ReportAlertRuleWizard from './ReportAlertRuleWizard';

interface AddReportAlertRuleButtonProps {
    reloadGridData?: () => void;
    handleHidePopup?: () => void;
    componentProps?: {
        elementId?: number;
    };
}

export default function AddReportAlertRuleGridButton({
    reloadGridData,
    handleHidePopup,
    componentProps,
}: AddReportAlertRuleButtonProps) {
    const elementId = componentProps?.elementId ?? 0;

    const handleClose = () => {
        handleHidePopup?.();
        reloadGridData?.();
    };

    return (
        <ReportAlertRuleWizard
            elementId={elementId}
            alertRuleId={0}
            isOpen={true}
            setIsOpen={(isOpen) => {
                if (!isOpen) {
                    handleClose();
                }
            }}
        />
    );
}
